import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { hasRole } from "components/stores/UserStore";

const ViewAsRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (hasRole(["vesselOwner-standard", "vesselOwner-admin"])) {
      void navigate("/port-calls");
    }
    if (hasRole(["vesselOwner-vesseluser"])) {
      void navigate("/my-vessel");
    }
    if (
      hasRole([
        "portOwner-admin",
        "portOwner-standard",
        "system-admin",
        "system-standard",
      ])
    ) {
      void navigate("/dashboard");
    }
    if (
      hasRole([
        "portService-admin",
        "portService-standard",
        "portControl-admin",
        "portControl-standard",
      ])
    ) {
      void navigate("/map");
    }
  }, [navigate]);

  return <></>;
};

export default ViewAsRedirect;
